export default "__VITE_ASSET__Ca$5Mt5i__"